// extracted by mini-css-extract-plugin
export default {"wrapper":"Tractors_wrapper__HbG7m","infiniteLoader":"Tractors_infiniteLoader__ndWIq","spin":"Tractors_spin__8SjE5"};